import { badgeVariantsBadge } from '@/components/ui/StatusBadge/StatusBadge';
import { StateTable } from '@/interfaces';
import { VariantProps } from 'class-variance-authority';

export const stateToVariantFormation: Record<
	StateTable,
	VariantProps<typeof badgeVariantsBadge>['variant']
> = {
	[StateTable.FACTURADA]: 'Facturada',
	[StateTable.PROGRAMADA]: 'Programada',
	[StateTable.DOCUMENTACION_ENVIADA]: 'Documentación enviada',
	[StateTable.EJECUTADA]: 'Ejecutada',
	[StateTable.CANCELADA]: 'Cancelada',
	[StateTable.POSTPUESTA]: 'Pospuesta',
	[StateTable.RECHAZADA]: 'Rechazada',
	[StateTable.EN_PROGRESO]: 'En progreso',
	[StateTable.DESCONOCIDO]: 'Desconocido',
	[StateTable.CONFIRMADA]: 'Confirmada',
	[StateTable.PLANIFICADA]: 'Planificada',
};
